import React from 'react';
import {compose, withProps, lifecycle} from 'recompose';
import {hot} from 'react-hot-loader';
import styled from 'styled-components';
import {Label} from 'semantic-ui-react';

export const NEGATIVE_SCORE = 20;

import {withLocale} from 'op/components/locale';
import {withReadyLoader} from 'op/components/loader';
import {withOnlineStatus} from 'op/components/offline';
import {withTypes, withExecutionLevels} from 'op/components/lut';


const EvaluationContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

const EvaluationComponent = ({locale, model, type, execution_level}) => (
    <EvaluationContainer>
       {type && 
       ['score', 'quantity'].includes(type.type) && !!model[type.type] &&
        <Label color='grey'>
            {type &&
             !locale._meta.rtl && model[type.type] }
            <Label.Detail>{ locale.mapping[type.type] }</Label.Detail>
            {type && 
            locale._meta.rtl && model[type.type] }
        </Label>}
        {type &&
        type.type === 'execution_level' && !!execution_level &&
        <Label color={model[type.type] > NEGATIVE_SCORE ? 'grey' : 'red'}>
            {execution_level.name}
        </Label>}
    </EvaluationContainer>
);

export const Evaluation = compose(
    withLocale('report.evaluation'),
    withTypes,
    withExecutionLevels('type.id'),
    withProps(({model, type, types, executionLevels}) => ({
        type: types.find(t => t.id === type.id),
        execution_level: executionLevels.find(el => el.id === model.execution_level),
        ready: types.length !== 0 && executionLevels.length !== 0,
    })),
    withOnlineStatus,
    lifecycle({
        componentDidMount() {
            if (this.props.online && !this.props.ready) {
                this.props.fetchExecutionLevels();
            }
        }
    }),
    hot(module)
)(EvaluationComponent);


const EvaluationInputComponent = ({value, type, invokeChange}) => (
    <input type='text' value={value} onChange={e => invokeChange('score', e.target.value)}/>
);

export const EvaluationInput = compose(
    hot(module),
)(EvaluationInputComponent);
